<div class="option__chips">
  @for (filterOption of selectedOptionData; track filterOption) {
    <ion-chip [class.disabled]="isChipDisable"
      ><ion-label>
        <app-text
          [textSize]="TextSizes.mobBody"
          [textType]="TextType.base"
          [text]="filterOption?.name ?? (filterOption | getFullName)"
        ></app-text>
      </ion-label>
      @if (!isChipDisable) {
        <app-image
          class="option__chips-delete"
          [img]="removeChip"
          (click)="removeElem(selectedOptionName, filterOption.id)"
        ></app-image>
      }
    </ion-chip>
  }
</div>
